module.exports = __webpack_public_path__ + "static/media/14.75942269.jpg";